module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_hambúrguer.187f0842.png";